import { BusinessUnit } from '@app/models/business-unit';
import { Action } from '@ngrx/store';

export enum BusinessUnitActionTypes {
  Load = '[BusinessUnit] Load',
  LoadSuccess = '[BusinessUnit] Load Success',
  LoadFail = '[BusinessUnit] Load Fail',
  Create = '[BusinessUnit] Create',
  CreateSuccess = '[BusinessUnit] Create Success',
  CreateFail = '[BusinessUnit] Create Fail',
  AddOne = "[BusinessUnit] Add One",
  AddOneSuccess = "[BusinessUnit] Add One Success",
  AddOneFail = "[BusinessUnit] Add One Fail",
  LoadByFollowId = "[BusinessUnit] Load By FollowId",
  LoadByFollowIdSuccess = "[BusinessUnit] Load By FollowId Success",
  LoadByFollowIdFail = "[BusinessUnit] Load By FollowId Fail",
  DeleteOne = "[BusinessUnit] Delete One",
  DeleteOneSuccess = "[BusinessUnit] Delete One Success",
  DeleteOneFail = "[BusinessUnit] Delete One Fail",
}

export class Load implements Action {
  readonly type = BusinessUnitActionTypes.Load;
  constructor(public data?: any) {}
}

export class LoadSuccess implements Action {
  readonly type = BusinessUnitActionTypes.LoadSuccess;
  constructor(public businessUnits: BusinessUnit[]) {}
}

export class LoadFail implements Action {
  readonly type = BusinessUnitActionTypes.LoadFail;
  constructor(public error: any) {}
}

export class LoadByFollowId implements Action {
  readonly type = BusinessUnitActionTypes.LoadByFollowId;
  constructor(public FollowId?: any) {}
}

export class LoadByFollowIdSuccess implements Action {
  readonly type = BusinessUnitActionTypes.LoadByFollowIdSuccess;
  constructor(public data: any) {}
}

export class LoadByFollowIdFail implements Action {
  readonly type = BusinessUnitActionTypes.LoadByFollowIdFail;
  constructor(public error: any) {}
}

export class Create implements Action {
  readonly type = BusinessUnitActionTypes.Create;
  constructor(public data: any) {}
}

export class CreateSuccess implements Action {
  readonly type = BusinessUnitActionTypes.CreateSuccess;
  constructor(public data: any) {}
}

export class CreateFail implements Action {
  readonly type = BusinessUnitActionTypes.CreateFail;
  constructor(public error: any) {}
}

export class AddOne implements Action {
  readonly type = BusinessUnitActionTypes.AddOne;
  constructor(public data: any) {}
}

export class AddOneSuccess implements Action {
  readonly type = BusinessUnitActionTypes.AddOneSuccess;
  constructor(public data: any, public FollowId?: any) {}
}

export class AddOneFail implements Action {
  readonly type = BusinessUnitActionTypes.AddOneFail;
  constructor(public error: any) {}
}

export class DeleteOne implements Action {
  readonly type = BusinessUnitActionTypes.DeleteOne;
  constructor(public data: any) {}
}

export class DeleteOneSuccess implements Action {
  readonly type = BusinessUnitActionTypes.DeleteOneSuccess;
  constructor(public BusinessId?: any) {}
}

export class DeleteOneFail implements Action {
  readonly type = BusinessUnitActionTypes.DeleteOneFail;
  constructor(public error: any) {}
}

export type BusinessUnitActionsUnion = 
Load | 
LoadSuccess | 
LoadFail |
Create |
CreateSuccess |
CreateFail |
AddOne |
AddOneSuccess |
AddOneFail |
LoadByFollowId | 
LoadByFollowIdSuccess |
LoadByFollowIdFail |
DeleteOne |
DeleteOneSuccess |
DeleteOneFail;
